import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { bankList } from '../../../store/actions/mitraActions'
import { officeList,  officeDelete } from '../../../store/actions/officeActions'
import { developerEdit, developerUpdate } from '../../../store/actions/developerActions'
import { Select } from 'antd';

const DeveloperEdit = () => {
  const [name, setname] = useState('')
  const [email, setemail] = useState('')
  const [phone, setphone] = useState('')
  const [joindate, setjoindate] = useState('')
  const [status, setstatus] = useState('')
  const [offices, setoffices] = useState('')
  const [bank, setbank] = useState([])

  const [search, setsearch] = useState('')
  let dispatch = useDispatch()
  let dispatchOf = useDispatch()
  let history = useHistory()
  const id = localStorage.getItem('id_developer');

  useEffect(() => {
    dispatch(developerEdit(id))
    dispatch(bankList()) 
    dispatchOf(officeList(1))
  }, [dispatch,dispatchOf, id])

  useEffect(() => {
        if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
    if (!userInfo.permission.includes("developer-edit")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
  }, []);

  const { Option } = Select;

  const dataofficeList = useSelector(state => state.officeList)
  const{ office, listsOffice } = dataofficeList


  const datadeveloperUpdate = useSelector(state => state.developerUpdate)
  const { validation } = datadeveloperUpdate

  const dataLogin = useSelector(state => state.login)
  const { userInfo } = dataLogin
  const updated_by = userInfo.user.id

  const datadeveloperEdit = useSelector(state => state.developerEdit)
  const { developer } = datadeveloperEdit

  const databankList = useSelector(state => state.bankList)
  const{ listsBank } = databankList

  useMemo(() => {
    if (developer) {
      setname(developer.name)
      setemail(developer.email)
      setphone(developer.phone)
      setjoindate(developer.join_date)
      setstatus(developer.active)
      setbank(developer.bank)
      setoffices(developer.id_office)
    }
  }, [developer])

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(bank);
    dispatch(developerUpdate(name, email, phone, joindate, status, bank, updated_by,  id, offices, history))
  }

  const handleChange = selectedItems => {
    setbank(selectedItems);
  }


  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Edit Developer</h3>
        </div>
      </div>
      <div className="clearfix"></div><br/>
      <div className="row">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>Form Input</h2>
              <div className="clearfix"></div>
            </div>
            
            <div className="x_content overflow-auto">  
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Name</label>
                      <input type="text" 
                        className={ validation.length !== 0 && validation['name'] ? 'form-control parsley-error' : 'form-control' }
                        required 
                        onChange={(e) => setname(e.target.value)}
                        value={name}
                      />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['name']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Email</label>
                      <input type="email" 
                        className={ validation.length !== 0 && validation['email'] ? 'form-control parsley-error' : 'form-control' }
                        required 
                        onChange={(e) => setemail(e.target.value)}
                        value={email}
                      />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['email']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Phone</label>
                      <input type="text" 
                        className={ validation.length !== 0 && validation['phone'] ? 'form-control parsley-error' : 'form-control' }
                        required 
                        onChange={(e) => setphone(e.target.value)}
                        value={phone}
                      />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['phone']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Join Date</label>
                      <input type="date" 
                        className={ validation.length !== 0 && validation['join_date'] ? 'form-control parsley-error' : 'form-control' }
                        name="name" 
                        required 
                        onChange={(e) => setjoindate(e.target.value)}
                        value={joindate}
                      />
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['join_date']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                </div>

                

                <div className="row">
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <label for="name">Status</label>
                      <select 
                        className={ validation.length !== 0 && validation['status'] ? 'form-control parsley-error' : 'form-control' }
                        required
                        onChange={(e) => setstatus(e.target.value)}
                        defaultValue={status}
                        value={status}
                      >
                        <option disabled selected value="">Select Status</option>
                        <option value="1">Active</option>
                        <option value="0">Deactive</option>
                      </select>
                      {
                        validation.length !== 0 
                        ?
                          <ul className="parsley-errors-list filled">
                            <li className="parsley-required">{validation['status']}</li>
                          </ul>
                        :
                          null
                      }
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label for="name">Bank</label>
                  <Select
                    mode="multiple"
                    value={bank}
                    size='large'
                    onChange={handleChange}
                    style={{ width: '100%' }}
                    options={listsBank}
                    optionFilterProp='label'
                  >
                  </Select>
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['bank']}</li>
                      </ul>
                    :
                      null
                  }
                </div>
                <div className='form-group mb-4'>
                  <label for="office">Select Loan Market Office</label>
                  <Select value={offices}  onChange={(e) => setoffices(e)} style={{ width: '100%' }} >
                    {(
                      listsOffice.length < '1' ? ''
                      :
                      listsOffice.map((item, index) => {
                        return(
                          <Option value={item.id} key={index}>{item.name}</Option>
                        )
                      })
                    )}
                    
                  </Select>
                </div>
                <button type="submit" className="btn btn-primary pull-right">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeveloperEdit
